import { getIn, useFormikContext } from 'formik'

import type { UpdateRequiredFieldsFormModel } from '../../typings'

/**
 * Whether the inputs of an OR-group still show the required asterisk: true until any member has a
 * value, since one filled member satisfies the whole group.
 */
export function useGroupRequired(members: readonly string[]) {
  const { values } = useFormikContext<UpdateRequiredFieldsFormModel>()

  return !members.some((member) => `${getIn(values, member) ?? ''}`.trim())
}
